export const triggerBlobDownload = ({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const downloadTextFile = ({
  content,
  contentType,
  filename,
}: {
  content: string;
  contentType: string;
  filename: string;
}) => {
  const blob = new Blob([content], { type: contentType });
  triggerBlobDownload({ blob, filename });
};

export const downloadBase64File = ({
  base64Data,
  contentType,
  filename,
}: {
  base64Data: string;
  contentType: string;
  filename: string;
}) => {
  const binary = window.atob(base64Data);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  const blob = new Blob([bytes], { type: contentType });
  triggerBlobDownload({ blob, filename });
};
